export default __webpack_public_path__ + "static/media/logo-black.768b7360.svg";